module.exports = __webpack_public_path__ + "static/media/tuigCloud.39567269.png";